import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import RubyOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/ruby.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  RubyOverrideServerProperties,
  React
};